var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArmas({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 67.7 65",
    style: {
      enableBackground: "new 0 0 67.7 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#4C4646;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#443F3F;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#EEBF49;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#D6AC42;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#3D3939;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#C88D25;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#FBFBFB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(-1.2 -17.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_473654952",
    transform: "translate(1.2 17.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_125",
    className: "st0",
    d: "M34.9,41.7C34.8,41.7,34.8,41.7,34.9,41.7l-8.6-0.4c-0.9,0-1.5-0.8-1.5-1.7 c0-0.9,0.7-1.5,1.6-1.5c0,0,0,0,0,0l8.4,0.4c0.6-0.1,4.4-0.6,5.1-5.7c0.4-2.5,0.6-4,0.6-4.7c0-0.3,0.1-0.7,0.2-1h0 c0-0.2,0.1-0.4,0.2-0.6c0.2-0.5,0.8-0.9,1.4-0.8c0.8,0.1,1.4,0.7,1.5,1.4c0,0.2,0,0.3,0,0.5c0,0,0,0.1,0,0.1 c0,0.4-0.2,1.7-0.7,5.4C42.2,39.6,37.4,41.6,34.9,41.7C34.9,41.7,34.9,41.7,34.9,41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_126",
    className: "st1",
    d: "M28.8,41.4l-2.5-0.1c-0.9,0-1.5-0.8-1.5-1.7c0-0.9,0.7-1.5,1.6-1.5c0,0,0,0,0,0l2.8,0.1 l-0.1,1C29,40,28.9,40.7,28.8,41.4z M40.3,30c0.1-0.9,0.2-1.5,0.2-1.9c0-0.3,0.1-0.7,0.2-1h0c0-0.2,0.1-0.4,0.2-0.6 c0.2-0.5,0.8-0.9,1.4-0.8c0.8,0.1,1.4,0.7,1.5,1.4c0,0.2,0,0.3,0,0.5c0,0,0,0.1,0,0.1c0,0.2-0.1,0.9-0.3,2.3L40.3,30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_127",
    className: "st2",
    d: "M34.8,35.2c-0.4,0-0.9-0.2-1.1-0.5l-4.6-4.8c-0.6-0.6-0.6-1.6,0.1-2.2c0,0,0,0,0,0 c0.6-0.6,1.6-0.6,2.3,0l4.5,4.9c0.6,0.6,0.6,1.6,0,2.2c0,0,0,0-0.1,0.1C35.7,35,35.3,35.2,34.8,35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_128",
    className: "st3",
    d: "M31,31.8l-1.9-1.9c-0.6-0.6-0.6-1.6,0.1-2.2c0,0,0,0,0,0c0.6-0.6,1.6-0.6,2.3,0l2.4,2.6 C32.7,30.2,31.6,30.8,31,31.8L31,31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_129",
    className: "st2",
    d: "M6,64.5c-0.3,0-0.6-0.1-0.9-0.3c-3.6-2.5-2.9-5.6-2.7-6.4c0.1-0.6,0.8-4.4,1.5-8.9l0.2-1.3 c0.8-4.4,1.3-8.9,1.5-13.4C5.8,30.5,5.1,30,4,29.4c-1.6-1-3-2.1-3.5-5.8c0-0.2,0-3.4-0.1-3.6c0.5,0.2,1,0.4,1.5,0.4h59.7v7.5 c0,0.9-0.7,1.6-1.6,1.6c-6.2,0-11.2-0.2-15.2-0.3c-7.7-0.3-12-0.4-13.9,1.2c-1.9,1.7-2.5,6.1-3.5,14.1c-0.5,4-1.1,9-2.2,15.2 c-0.6,3.5-2.9,4.7-4.2,4.8c-0.1,0-0.1,0-0.2,0L6,64.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_130",
    className: "st3",
    d: "M0.4,22.5c0-1,0-2.3,0-2.5c0.5,0.2,1,0.4,1.5,0.4h59.7v2.5H1.8C1.3,22.9,0.8,22.7,0.4,22.5z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_131",
    className: "st0",
    d: "M66.1,21.8H1.8c-0.9,0-1.6-0.7-1.5-1.6c0,0,0,0,0,0v-5.5c0-4.9,4-9,8.9-9c0,0,0,0,0,0h56.9 c0.9,0,1.6,0.7,1.6,1.6v12.9C67.7,21.1,67,21.8,66.1,21.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_324",
    transform: "translate(7.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_132",
    className: "st4",
    d: "M0.3,6V4.1C0.2,2.8,1.2,1.6,2.5,1.5h2c2.9,0.1,5.5,1.7,6.8,4.3H2.5C1.8,5.8,1,5.9,0.3,6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_133",
    className: "st4",
    d: "M52.4,5.7V3.2c0-0.9,0.8-1.6,1.6-1.5c0.8,0,1.5,0.7,1.5,1.6l0,2.5L52.4,5.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_325",
    transform: "translate(10.062 32.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_134",
    className: "st5",
    d: "M4.1,2.2L0.3,25.4c-0.1,0.4,0.2,0.8,0.6,0.9c0,0,0.1,0,0.1,0c0.4,0,0.7-0.3,0.8-0.7 L5.6,2.4C5.7,2,5.4,1.6,5,1.5S4.1,1.8,4.1,2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_135",
    className: "st5",
    d: "M9.6,2.2L5.8,25.4c-0.1,0.4,0.2,0.8,0.6,0.9c0.1,0,0.1,0,0.2,0c0.4,0,0.7-0.3,0.8-0.7 l3.8-23.2c0-0.4-0.3-0.8-0.7-0.8C10.1,1.6,9.7,1.8,9.6,2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_326",
    transform: "translate(6.306 9.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_136",
    className: "st6",
    d: "M4.3,1.8L0.5,5.6c-0.3,0.3-0.3,0.8,0,1.1c0,0,0,0,0,0c0.1,0.2,0.3,0.3,0.6,0.2 c0.2,0,0.4-0.1,0.6-0.2l3.8-3.8c0.3-0.3,0.3-0.8,0-1.1C5.1,1.5,4.6,1.5,4.3,1.8L4.3,1.8L4.3,1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_137",
    className: "st6",
    d: "M10.1,1.8L6.3,5.6C6,5.9,6,6.3,6.3,6.7c0,0,0,0,0,0c0.1,0.2,0.3,0.2,0.6,0.2 c0.2,0,0.4-0.1,0.6-0.2l3.8-3.8c0.3-0.3,0.3-0.8,0-1.1C11,1.5,10.5,1.4,10.1,1.8C10.2,1.7,10.1,1.8,10.1,1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_138",
    className: "st6",
    d: "M15.9,1.8l-3.8,3.8c-0.3,0.3-0.3,0.8,0,1.1c0,0,0,0,0,0c0.3,0.3,0.8,0.3,1.1,0c0,0,0,0,0,0 L17,2.9c0.3-0.3,0.3-0.8,0-1.1C16.7,1.5,16.2,1.5,15.9,1.8L15.9,1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_139",
    className: "st6",
    d: "M25.6,3.4c-0.4,0-0.8,0.4-0.8,0.8c0,0.4,0.3,0.7,0.8,0.8h28.7c0.4,0,0.8-0.4,0.8-0.8 c0-0.4-0.3-0.7-0.8-0.8H25.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArmas);
export default __webpack_public_path__ + "static/media/icon-armas.60739ed7bc94f7e89081246d3edf9dd7.svg";
export { ForwardRef as ReactComponent };